import React, { useEffect, useState } from "react";

import { Button, Col, Container, Row } from "react-bootstrap";
// import Banner from "../../components/common/banner";
import { useLocation, useNavigate } from "react-router-dom";
import Noimage from "../../assets/images/no-image.png";

import { postData } from "../../api";
import AdminHeader from "../../components/common/admin-header";

let imageUrl = "https://www.centillionsoftechhrm.com/api/static/portfolio/";

const ViewPortFolio = () => {
  const navigation = useNavigate();
  const [gallery, setGallery] = useState();
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  let location = useLocation();

  let [albumId] = useState(new URLSearchParams(location.search).get("id"));

  // useEffect(() => {
  //   const galleryList = async () => {
  //     const url = `${process.env.REACT_APP_BASEURL}/admin/portfolio/get`;
  //     const result = await postData(url, { _id: albumId });
  //     if (result.data.data) {
  //       setGallery(result.data.data[0]);
  //     }
  //   };
  //   galleryList();
  // }, [albumId]);

  const handleGalleryButtonClick = () => {
    setIsGalleryOpen(true);
  };

  return (
    <>
      {/* <Banner title="Admin PortFolio View" /> */}
      <Container className="mt-3 mb-3">
        <AdminHeader />
        <div class="row">
          <Col md={4}>
            <button
              class="btn btn-primary"
              style={{
                position: "absolute",
                right: 0,
                marginTop: "15px",
                marginRight: "10px",
              }}
              onClick={() => window.history.back()}
            >
              Back
            </button>
          </Col>
        </div>
        <section class="pt-5 pb-5">
          <div class="container">
            <div class="row">
              <Col lg={6}>
                <div class="services-block-three">
                  <img
                    src={
                      gallery?.coverPhoto
                        ? imageUrl + gallery.coverPhoto
                        : Noimage
                    }
                    className="w-100 shadow-1-strong rounded mb-4 image-hover"
                    alt="CoverImage"
                    style={{
                      width: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>
              </Col>
              <Col lg={6}>
                <div className="p-3">
                  {gallery && gallery.link ? (
                    <div className="text-end">
                      <a
                        variant="secondary"
                        href={gallery.link}
                        target="_blank"
                        className="text-center btn btn-primary"
                      >
                        Visit
                      </a>
                      {gallery?.otherPhotos &&
                      gallery?.otherPhotos?.length > 0 ? (
                        <Button
                          className="text-center btn btn-primary"
                          onClick={handleGalleryButtonClick}
                          style={{ marginLeft: "5px" }}
                        >
                          Gallery
                        </Button>
                      ) : (
                        ""
                      )}
                      {/* <a
                        href={"/admin-portFolio/edit?id=" + albumId}
                        className="text-center btn btn-primary"
                        style={{ marginLeft: "5px" }}
                      >
                        Edit
                      </a> */}
                    </div>
                  ) : (
                    ""
                  )}
                  <p>
                    <b>Project Name:</b> {gallery && gallery.projectName}
                  </p>
                  <p>
                    <b>Project Short Description: </b>{" "}
                    {gallery && gallery.shortDescription}
                  </p>
                  <p>
                    <b>Client Feedback: </b> {gallery && gallery.clientFeedback}
                  </p>
                  <p>
                    <b>Project long Description: </b>{" "}
                    {gallery && gallery.longDescription}
                  </p>
                </div>
              </Col>
            </div>
          </div>
          {/* <div class="row">
              {isGalleryOpen && gallery.length > 0 && (
                gallery?.map((item, i) => {
                  let divider =
                    (i + 1) / 3 === 1 ? (
                      <div class="w-100 d-none d-md-block mt-3"></div>
                    ) : (
                      ""
                    );
                  let url = `/admin-portFolio/view?id=${item._id}`;
                  return (
                    <>
                      <div
                        class="col-lg-4 col-md-6 margin-30px-bottom xs-margin-20px-bottom "
                        key={i}
                      >
                        <div
                          class="services-block-three"
                          style={{ cursor: "pointer" }}
                        >
                          <div className="a">
                            <div
                              className="click"
                              onClick={() => navigation(url)}
                            >
                              <img
                                src={imageUrl + item?.coverPhoto}
                                class="w-100 shadow-1-strong rounded mb-4 image-hover"
                                alt="Boat on Calm Water"
                                style={{
                                  // objectFit: "cover",
                                  height: "150px",
                                }}
                              />
                              <div
                                className=""
                                style={{ height: "150px", overflow: "hidden" }}
                              >
                                <p className="text-start">
                                  projectName : {item.projectName}
                                </p>
                                <p className="text-start">
                                  shortDescription : {item.shortDescription}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>

                        {divider}
                      </div>
                    </>
                  );
                })
              )}

            </div> */}
          <div class="row">
            {isGalleryOpen &&
              gallery?.otherPhotos?.map((item, i) => {
                let divider =
                  (i + 1) / 3 === 1 ? (
                    <div class="w-100 d-none d-md-block mt-3"></div>
                  ) : (
                    ""
                  );
                let url = `/admin-portFolio/view?id=${item._id}`;
                return (
                  <>
                    <div
                      class="col-lg-4 col-md-6 margin-30px-bottom xs-margin-20px-bottom "
                      key={i}
                    >
                      <div
                        class="services-block-three"
                        style={{ cursor: "pointer" }}
                      >
                        <div className="a">
                          <div
                            className="click"
                            onClick={() => navigation(url)}
                          >
                            <img
                              src={imageUrl + item?.coverPhoto}
                              class="w-100 shadow-1-strong rounded mb-4 image-hover"
                              alt="Boat on Calm Water"
                              style={{
                                // objectFit: "cover",
                                height: "150px",
                              }}
                            />
                            <div
                              className=""
                              style={{ height: "150px", overflow: "hidden" }}
                            ></div>
                          </div>
                        </div>
                      </div>

                      {divider}
                    </div>
                  </>
                );
              })}
          </div>
        </section>
      </Container>
    </>
  );
};

export default ViewPortFolio;
